// extracted by mini-css-extract-plugin
export default {"container":"Fca-z","oos":"Gca-z","oosUx":"Hca-z","selected":"Ica-z","labelOos":"Jca-z"};